// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__yunXS","socialIcons":"Footer_socialIcons__RhpXs","footerSocialIcons":"Footer_footerSocialIcons__oDQgf"};